import SignUpModalContentV3 from './sign_up_modal_v3';
export default SignUpModalContentV3;
